/// <amd-module name="RMWidgets/DeploymentStatusWidget/DSWState" />
import {
    IDSWBuildInfo,
    IDSWBuildDefinitionInfo,
    IDSWEnvironmentInfo,
    IDSWDeploymentInfo,
    IDSWTestResultInfo,
    IDSWLastColumnInfo
} from "RMWidgets/DeploymentStatusWidget/DSWContracts";

export interface DSWState {
    branchName: string;
    builds: IDSWBuildInfo[];
    environmentsInfo: IDSWEnvironmentInfo[];
    deploymentsMap: { [definitionEnvironmentId: number]: { [buildId: number]: IDSWDeploymentInfo } };
    testResultsMap: { [releaseEnvironmentId: number]: IDSWTestResultInfo };
    lastColumnMap: { [definitionEnvironmentId: number]: IDSWLastColumnInfo };
    buildDefinitionInfo: IDSWBuildDefinitionInfo | undefined;
}
